const PLATFORM_REGEX = [
  { name: "youtube", label: "YouTube", re: /(?:youtube\.com|youtu\.be)/i },
  { name: "tiktok", label: "TikTok", re: /tiktok\.com/i },
  { name: "instagram", label: "Instagram", re: /instagram\.com/i },
  { name: "twitter", label: "X / Twitter", re: /(?:twitter\.com|x\.com)/i },
  { name: "facebook", label: "Facebook", re: /(?:facebook\.com|fb\.watch)/i },
];

export function detectPlatform(url) {
  if (!url) return null;
  const entry = PLATFORM_REGEX.find((p) => p.re.test(url.trim()));
  return entry ? entry.name : null;
}

export function platformLabel(url) {
  const entry = PLATFORM_REGEX.find((p) => p.re.test((url || "").trim()));
  return entry ? entry.label : "Unknown";
}

export function isSupportedUrl(url) {
  return detectPlatform(url) !== null;
}

// Backward-compat exports (some components still import from youtube.js)
export function isYoutubeUrl(url) {
  return isSupportedUrl(url);
}

export function extractYoutubeId(url) {
  if (!url) return null;
  const m = url.match(/(?:v=|be\/|shorts\/|embed\/)([A-Za-z0-9_-]{11})/);
  return m ? m[1] : null;
}
